import {
  SITE_NAME,
  SITE_ALTERNATE_NAME,
  SITE_URL,
  SITE_DESCRIPTION,
} from './seo';

function buildJsonLd(path: string): object | null {
  if (path === '/') {
    return {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebSite',
          name: SITE_NAME,
          alternateName: SITE_ALTERNATE_NAME,
          url: `${SITE_URL}/`,
          description: SITE_DESCRIPTION,
        },
        {
          '@type': 'Organization',
          name: SITE_NAME,
          alternateName: SITE_ALTERNATE_NAME,
          url: `${SITE_URL}/`,
          description: SITE_DESCRIPTION,
        },
      ],
    };
  }

  if (path === '/inquiry') {
    return {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: '문의 및 건의사항 - MC에듀',
      url: `${SITE_URL}/inquiry`,
      description:
        'MC에듀 서비스 이용 중 궁금한 점이나 건의사항을 남겨주세요. 진로·계열 탐색, 선택과목 추천, 공부법 검사, IQ 검사, 어휘력·문해력 검사 관련 문의를 안내드립니다.',
    };
  }

  if (path === '/terms' || path === '/privacy') {
    return {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: path === '/terms' ? '이용약관 - MC에듀' : '개인정보처리방침 - MC에듀',
      url: `${SITE_URL}${path}`,
    };
  }

  return null;
}

export function injectJsonLd(path: string): void {
  const data = buildJsonLd(path);
  if (!data) return;
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-seo-jsonld', 'true');
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function removeJsonLd(): void {
  document
    .querySelectorAll('script[data-seo-jsonld="true"]')
    .forEach((el) => el.remove());
}